import React from "react";
// import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import AccountPayableOverView from "./AccountPayableOverView";
import PendingTransaction from "./PendingTransaction";
import ComplianceOver from "./ComplainOver";
import OutStandingQueries from "./OutStandingQueries";
import PurchaseOrderCompilance from "./PurchaseOrderCompilance";
import AccountPayableCountTable from "./AccountPayableCountTable";
import axios from "axios";
import InvoiceProcessingdays from "./InvoiceProcessingdays";
import VendorFinancingTable from "./VendorFinancingTable";
import ChequeMade from "./ChequeMade";
import CustomSnackbar from "../../../CustomSnackbar";
import CircularProgress from "@mui/material/CircularProgress";
import { useEffect, useState } from "react";
import ShippingPayment from "./ShippingPayment";
import EmpolyeeMade from "./EmployeeMade";
import PaymentSummary from "./PaymentSummary";
import { FormatAmount } from '../FormatAmount';
import Skeleton from "@mui/material/Skeleton";
import DashboardAccountPayableCounts from "./DashboardAccountPayableCounts";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  Autocomplete,
  Button,
  TextField,
  Grid,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Collapse,
  Box,
  Typography,
  TableCell,
  TableRow,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Error } from "@material-ui/icons";
import { dashboardStyle } from "../../Invoices/Components/InvoiceDetails/style";
import {
  ExpandMore,
  ExpandLess,
  BarChart,
  ReceiptLong,
  AssignmentTurnedIn,
  Autorenew,
  RequestQuote,
  Payments,
  AccountBalance,
  Assessment,
  FactCheck,
  PendingActions,
  Summarize,
  QueryStats,
  Timeline,
  People,
  MonetizationOn,
  SupportAgent,
} from "@mui/icons-material";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

export default function AdminDashboard() {
  const [PayableCountsList, setPayableCounts] = useState(null);
  const [fetchedData, setFetchedData] = useState(false);
  const [monthOptions, setMonthOptions] = useState([]);
  const [dashboardStats, setDashboardStats] = useState(null);
  const [listPayable, setListPayable] = useState([]);
  const [invoiceProcessingData, setInvoiceProcessingData] = useState([]);
  const [complianceData, setComplianceData] = useState([]);
  const [listPayment, setListPayment] = useState([]);
  const [loading, setLoading] = useState(false);
  const [series, setSeries] = useState([]);
  const [categories, setCategories] = useState([]);
  const [querySeries, setQuerySeries] = useState([]);
  const [purchaseOrderCompilance, setPurchaseOrderCompilance] = useState([]);
  const [invoicesSummaryExpanded, setInvoicesSummaryExpanded] = useState(true);
  const [filter, setFilter] = useState({
    month: "",
    year: "",
    startDate: "",
    endDate: "",
  });
  const [errorMessage, setErrorMessage] = useState({
    monthError: "",
    yearError: "",
    startDateError: "",
    endDateError: "",
  });
  const[apiErrorMessage, setApiErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");


  const useStyles = makeStyles(dashboardStyle);
  const classes = useStyles();

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const currentMonthIndex = new Date().getMonth();
  const months = Array.from({ length: currentMonthIndex + 1 }, (_, i) => ({
    value: i + 1,
    label: `${i + 1} - ${monthNames[i]}`,
  }));
  const currentYear = new Date().getFullYear();

  const Validyears = Array.from(
    { length: currentYear - 2023 + 1 },
    (_, i) => 2023 + i
  );
  // useEffect(() => {
  //   if (fetchedData) {
  //     fetchData();
  //   }
  // }, [fetchedData]);

  useEffect(() => {
  const selectedYear = filter?.year;
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();

  let updatedMonths = [];

  if (selectedYear) {
    const maxMonth =
    selectedYear < currentYear
          ? 12
          : selectedYear === currentYear
          ? currentMonth + 1
          : 0;
      updatedMonths = Array.from({ length: maxMonth }, (_, i) => ({
        value: i + 1,
        label: `${i + 1} - ${monthNames[i]}`,
      }));
    }
  setMonthOptions(updatedMonths);
}, [filter?.year]);

// Common function for downloading a specific card as PDF or Excel

const handleDownload = async (cardId, type, fileName) => {
  const cardElement = document.getElementById(cardId);
  if (!cardElement) return;

  // ✅ Hide elements you don’t want in export
  const hiddenElements = cardElement.querySelectorAll(".hide-on-download");
  hiddenElements.forEach((el) => (el.style.display = "none"));

  // ✅ Expand scrollable containers
  const scrollableEls = cardElement.querySelectorAll("*");
  const originalStyles = [];
  scrollableEls.forEach((el) => {
    const style = window.getComputedStyle(el);
    if (style.overflowY === "auto" || style.overflowY === "scroll") {
      originalStyles.push({
        el,
        style: {
          overflowY: el.style.overflowY,
          maxHeight: el.style.maxHeight,
          height: el.style.height,
        },
      });
      el.style.overflowY = "visible";
      el.style.maxHeight = "none";
      el.style.height = "auto";
    }
  });

  // ✅ Capture screenshot with full expanded content
  const canvas = await html2canvas(cardElement, {
    scale: 2,
    useCORS: true,
    scrollY: 0,
  });
  const imgData = canvas.toDataURL("image/png");

  // ✅ Restore original scrollable styles
  originalStyles.forEach(({ el, style }) => {
    el.style.overflowY = style.overflowY;
    el.style.maxHeight = style.maxHeight;
    el.style.height = style.height;
  });

  // ✅ Restore hidden elements
  hiddenElements.forEach((el) => (el.style.display = ""));

  // ✅ Continue with PDF or Excel export
  const monthNames = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December"
  ];
  const monthName =
    typeof filter.month === "number" && filter.month >= 1 && filter.month <= 12
      ? monthNames[filter.month - 1]
      : filter.month || "N/A";

  // ------------------ PDF EXPORT ------------------
  // ------------------ PDF EXPORT (multi-page) ------------------
if (type === "pdf") {
  const pdf = new jsPDF("p", "mm", "a4");
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();

  const margin = 12;
  const headerHeight = 30;
  const availableY = headerHeight + margin;
  const availableHeight = pdfHeight - availableY - margin;

  // Header background
  pdf.setFillColor(230, 247, 255);
  pdf.rect(0, 0, pdfWidth, headerHeight, "F");

  // Header text
  pdf.setTextColor(30, 30, 30);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(16);
  pdf.text("Dashboard Report", pdfWidth / 2, 15, { align: "center" });

  pdf.setFontSize(12);
  pdf.setFont("helvetica", "normal");
  pdf.text(`${monthName} ${filter.year || "N/A"}`, pdfWidth / 2, 24, {
    align: "center",
  });

  // Add image (multi-page logic)
  const imgProps = pdf.getImageProperties(imgData);
  const imgWidth = pdfWidth - margin * 2;
  const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

  let heightLeft = imgHeight;
  let position = availableY;
  let pageHeightAvailable = availableHeight;

  let page = 1;

  // Loop to add pages
  while (heightLeft > 0) {
    const cropHeight = Math.min(pageHeightAvailable, heightLeft);
    const srcY = imgProps.height * (1 - heightLeft / imgHeight);
    const cropCanvas = document.createElement("canvas");
    cropCanvas.width = imgProps.width;
    cropCanvas.height = (cropHeight / imgHeight) * imgProps.height;

    const ctx = cropCanvas.getContext("2d");
    const img = new Image();
    img.src = imgData;
    await new Promise((res) => {
      img.onload = () => {
        ctx.drawImage(
          img,
          0,
          srcY,
          imgProps.width,
          cropCanvas.height,
          0,
          0,
          imgProps.width,
          cropCanvas.height
        );
        res();
      };
    });

    const pageData = cropCanvas.toDataURL("image/png");
    pdf.addImage(
      pageData,
      "PNG",
      margin,
      availableY,
      imgWidth,
      cropHeight,
      undefined,
      "FAST"
    );

    heightLeft -= pageHeightAvailable;
    if (heightLeft > 0) {
      pdf.addPage();
      page++;
    }
  }

  pdf.save(`${fileName}.pdf`);
}


  // ------------------ EXCEL EXPORT ------------------
// ------------------ EXCEL EXPORT (responsive image) ------------------
else if (type === "excel") {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Snapshot");

  // Header cells
  sheet.getCell("A1").value = "Dashboard Report";
  sheet.getCell("A1").font = { bold: true, size: 16 };
  sheet.mergeCells("A1:C1");
  sheet.getCell("A1").alignment = { horizontal: "center" };
  sheet.getCell("A2").value = `${monthName} ${filter.year || "N/A"}`;
  sheet.mergeCells("A2:C2");
  sheet.getCell("A2").alignment = { horizontal: "center" };

  // Add image below header
  const imageId = workbook.addImage({
    base64: imgData,
    extension: "png",
  });

  // Get actual image size
  const img = new Image();
  img.src = imgData;
  await new Promise((res) => (img.onload = res));

  // Convert pixel dimensions → Excel units
  const PX_TO_COL = 7.5; // Roughly: 1 Excel column ≈ 7.5 pixels
  const PX_TO_ROW = 0.75; // Roughly: 1 Excel row ≈ 0.75 pixels

  let imgWidth = img.width;
  let imgHeight = img.height;

  // ✅ Limit max width/height (for huge dashboards)
  const maxWidth = 1200;
  const maxHeight = 1600;

  if (imgWidth > maxWidth) {
    const scale = maxWidth / imgWidth;
    imgWidth *= scale;
    imgHeight *= scale;
  }
  if (imgHeight > maxHeight) {
    const scale = maxHeight / imgHeight;
    imgWidth *= scale;
    imgHeight *= scale;
  }

  // Insert image with responsive scaling
  sheet.addImage(imageId, {
    tl: { col: 0, row: 4 },
    ext: { width: imgWidth, height: imgHeight },
  });

  // Adjust row heights to fit image
  const rowsNeeded = Math.ceil(imgHeight / PX_TO_ROW / 15); // each row ~15pt height
  for (let i = 4; i < 4 + rowsNeeded; i++) {
    sheet.getRow(i).height = 15; // keeps proportion consistent
  }

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), `${fileName}.xlsx`);
}

};





 const fetchAllDashboardData = async () => {
  setLoading(true);
  setFetchedData(true);

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("user_token")}`,
  };

  const month = filter?.month;
  const year = filter?.year;
  const baseUrl = process.env.REACT_APP_API_URL;

  try {
    const [
      dashboardStatsRes,
      payableCountsRes,
      payableOverviewRes,
      complianceRes,
      overviewIPDaysRes,
      pendingTransRes,
      paymentSummaryRes,
      outstandingQueriesRes,
      purchaseOrderCompRes,
    ] = await Promise.all([
      axios.get(`${baseUrl}/api/Dashboard/DashboardStats?fromDate=${filter.startDate}&toDate=${filter.endDate}`, { headers }),
      axios.get(`${baseUrl}/api/Dashboard/DashboardAccountPayableCounts?fromDate=${filter.startDate}&toDate=${filter.endDate}`, { headers }),
      axios.get(`${baseUrl}/api/Dashboard/DashboardAccountsPayableOverview?fromDate=${filter.startDate}&toDate=${filter.endDate}`, { headers }),
      axios.get(`${baseUrl}/api/Dashboard/DashboardCreditTermComplaince?fromDate=${filter.startDate}&toDate=${filter.endDate}`, { headers }),
      axios.get(`${baseUrl}/api/Dashboard/DashboardAOverviewIPDays?fromDate=${filter.startDate}&toDate=${filter.endDate}`, { headers }),
      axios.get(`${baseUrl}/api/Dashboard/DashboardOverviewPendingTrans?fromDate=${filter.startDate}&toDate=${filter.endDate}`, { headers }), // 👈 added
      axios.get(`${baseUrl}/api/Dashboard/DashboardPaymentSummary?fromDate=${filter.startDate}&toDate=${filter.endDate}`, { headers }), // 👈 new
      axios.get(`${baseUrl}/api/Dashboard/DashboardOutstandingQueries?fromDate=${filter.startDate}&toDate=${filter.endDate}`, { headers }),
      axios.get(`${baseUrl}/api/Dashboard/DashboardPurchaseOrderComp?fromDate=${filter.startDate}&toDate=${filter.endDate}`, { headers }), // 👈 added
    ]);

    // ✅ Update all your states here
    setDashboardStats(dashboardStatsRes?.data?.response?.[0]);
    setPayableCounts(payableCountsRes?.data?.response?.[0]);
    setListPayable(payableOverviewRes?.data?.response);
    setComplianceData(complianceRes?.data?.response || []);
    setInvoiceProcessingData(overviewIPDaysRes?.data?.response || []); // ✅ for child

        const pendingData = pendingTransRes?.data?.response?.[0];
    const processedData = [
      parseInt(pendingData.supervisorPending, 10),
      parseInt(pendingData.ipPending, 10),
      parseInt(pendingData.loamApproverPending, 10),
      parseInt(pendingData.reviewerPending, 10),
      parseInt(pendingData.deptCoPending, 10),
      parseInt(pendingData.queriesPending, 10),
      parseInt(pendingData.taxPending, 10),
      parseInt(pendingData.irPending, 10),
      // parseInt(pendingData.overAllPending, 10),
    ];

    setSeries([{ name: "Pending", data: processedData }]);
    setListPayment(paymentSummaryRes?.data?.response || []);
        // ✅ Outstanding Queries Data
    const outstandingData = outstandingQueriesRes?.data?.response || [];
    const names = outstandingData.map(item => item.name);
    const lessThan3Days = outstandingData.map(item => parseInt(item.lessThan3Days, 10));
    const lessThan7Days = outstandingData.map(item => parseInt(item.lessThan7Days, 10));
    const moreThan7Days = outstandingData.map(item => parseInt(item.moreThan7Days, 10));

    setCategories(names);
    setQuerySeries([
      { name: "0-3 Days", data: lessThan3Days },
      { name: "4-7 Days", data: lessThan7Days },
      { name: "More than 7 Days", data: moreThan7Days },
    ]);
    setPurchaseOrderCompilance(purchaseOrderCompRes?.data?.response);
setSuccessMessage("Dashboard data fetched successfully");

  } catch (error) {
        // clear any partially shown data
    setDashboardStats(null);
    setPayableCounts(null);
    setListPayable([]);
    setComplianceData([]);
    setInvoiceProcessingData([]);
    setSeries([]);
    setListPayment([]);
    setCategories([]);
    setQuerySeries([]);
    setPurchaseOrderCompilance([]);
    setApiErrorMessage('Failed to fetch dashboard data. Please try again.');
  } finally {
    setLoading(false);
    setFetchedData(false);
  }
};

  // const changeHandler = (name, value) => {
  // const now = new Date();
  // const currentYear = now.getFullYear();
  // const currentMonth = now.getMonth() + 1;
  // if(name === "month"){
  //   if (!filter?.year) {
  //     setErrorMessage({
  //       ...errorMessage,
  //       monthError: "Please select year first",
  //     });
  //     return;
  //   }
  //   if (filter.year > currentYear || 
  //       (filter.year == currentYear && value > currentMonth)) {
  //     setErrorMessage({
  //       ...errorMessage,
  //       monthError: "Invalid month for selected year",
  //     });
  //     return;
  //   }
  //   setFilter({
  //       ...filter, 
  //       month : value,
  //     });
  //     if(value !== null || value !== "") {
  //       setErrorMessage({
  //         ...errorMessage,
  //         monthError: "",
  //       });
  //     }
  //   }
  //  if (name === "year") {
  // setFilter({
  //   ...filter, 
  //   year: value,
  //   month: "",
  // });

  //     if(value !== null || value !== ""){
  //       setErrorMessage({
  //         ...errorMessage,
  //         yearError: "",
  //       });
  //     }
  //   }
  // };


// const filterHandler = () => {
//   if (!filter?.year) {
//     setErrorMessage({
//       ...errorMessage,
//       yearError: "Please Select Year",
//     });
//     return;
//   }

//   if (!filter?.month) {
//     setErrorMessage({
//       ...errorMessage,
//       monthError: "Please Select Month",
//     });
//     return;
//   }

//   // Errors clear
//   setErrorMessage({
//     ...errorMessage,
//     monthError: "",
//     yearError: "",
//   });

//   // Loading state
//   setFetchedData(true);

//   // fetchPayableCounts();
//   fetchAllDashboardData();
// };

const changeHandler = (name, value) => {
  if (name === "startDate") {
    setFilter({
      ...filter,
      startDate: value,
      endDate: "", // reset end date when start date changes
    });
    setErrorMessage({
      ...errorMessage,
      startDateError: "",
      endDateError: "",
    });
  }

  if (name === "endDate") {
    // Validate end date is not before start date
    if (filter.startDate && new Date(value) < new Date(filter.startDate)) {
      setErrorMessage({
        ...errorMessage,
        endDateError: "End date cannot be earlier than start date",
      });
      return;
    }

    setFilter({
      ...filter,
      endDate: value,
    });

    setErrorMessage({
      ...errorMessage,
      endDateError: "",
    });
  }
};

const filterHandler = () => {
  if (!filter?.startDate) {
    setErrorMessage({
      ...errorMessage,
      startDateError: "Please select start date",
    });
    return;
  }

  if (!filter?.endDate) {
    setErrorMessage({
      ...errorMessage,
      endDateError: "Please select end date",
    });
    return;
  }

  // End date should not be before start date
  if (new Date(filter.endDate) < new Date(filter.startDate)) {
    setErrorMessage({
      ...errorMessage,
      endDateError: "End date cannot be earlier than start date",
    });
    return;
  }

  // Clear errors
  setErrorMessage({
    ...errorMessage,
    startDateError: "",
    endDateError: "",
  });

  // Loading state
  setFetchedData(true);

  fetchAllDashboardData();
};

const openGuideInNewTab = () => {
  const baseUrl = window.location.origin;
  const pdfUrl = `/dashboardmanual/home.html`;
  const fullUrl = `${baseUrl}${pdfUrl}`;
  window.open(fullUrl, '_blank');
};

//  const fetchPayableCounts = async () => {
//         try {
//             const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Dashboard/DashboardAccountPayableCounts?Month=${filter?.month}&Year=${filter?.year}`, {
//                 headers: {
//                     "Content-Type": "application/json",
//                     Authorization: `Bearer ${localStorage.getItem("user_token")}`,
//                 },

//             })
//             console.log("responsePO", response?.data?.response[0]);
//             setPayableCounts(response?.data?.response[0])
//         } catch (error) {
//             console.log("error", error);
//         }
//     }

// const fetchPayableOverview = async () => {
//   setLoading(true);
//   try {
//     const response = await axios.get(
//       `${process.env.REACT_APP_API_URL}/api/Dashboard/DashboardAccountsPayableOverview?Month=${filter?.month}&Year=${filter?.year}`,
//       {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("user_token")}`,
//         },
//       }
//     );
//     setListPayable(response?.data?.response);
//   } catch (error) {
//     console.log("error", error);
//   } finally {
//     setLoading(false);
//   }
// };
// useEffect(() => {
//   if (filter?.month && filter?.year && fetchedData) {
//     fetchPayableOverview();
//   }
// }, [filter, fetchedData]);

// const fetchComplianceData = async () => {
//     try {
//         const response = await axios.get(
//             `${process.env.REACT_APP_API_URL}/api/Dashboard/DashboardCreditTermComplaince?Month=${filter?.month}&Year=${filter?.year}`,
//             {
//                 headers: {
//                     "Content-Type": "application/json",
//                     Authorization: `Bearer ${localStorage.getItem("user_token")}`,
//                 },
//             }
//         );
//         setComplianceData(response?.data?.response || []);
//     } catch (error) {
//         console.log("Error fetching compliance data", error);
//     }
// };
// useEffect(() => {
//     if (fetchedData) {
//         fetchComplianceData();
//     }
// }, [fetchedData]);

  // const [invoiceRecievedExpanded, setInvoiceRecievedExpanded] = useState(true);
  // const [invoiceProcessedExpanded, setInvoiceProcessedExpanded] = useState(true);
  // const [invoiceInProcessExpanded, setInvoiceInProcessExpanded] = useState(true);
  const [prePaymentExpanded, setPrePaymentExpanded] = useState(true);
  const [shipmentPaymentExpanded, setShipmentPaymentExpanded] = useState(true);
  const [chequeMadeExpanded, setChequeMadeExpanded] = useState(true);
  const [employeeClaimExpanded, setEmployeeClaimExpanded] = useState(true);
  const [accountPayableExpanded, setAccountPayableExpanded] = useState(true);
  const [creditTermComplainceExpanded, setCreditTermComplainceExpanded] = useState(true);
  const [overViewExpanded, setOverViewExpanded] = useState(true);
  const [paymentSummaryExpanded, setPaymentSummaryExpanded] = useState(true);
  const [outStandingQueriesExpanded, setOutStandingQueriesExpanded] = useState(true);
  const [purchaseOrderExpanded, setPurchaseOrderExpanded] = useState(true);
  const [invoiceProcessingExpanded, setInvoiceProcessingExpanded] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [vendorMenuAnchor, setVendorMenuAnchor] = useState(null);
const [shippingMenuAnchor, setShippingMenuAnchor] = useState(null);
const [chequeMenuAnchor, setChequeMenuAnchor] = useState(null);
const [employeeMenuAnchor, setEmployeeMenuAnchor] = useState(null);
const [accountsPayableMenuAnchor, setAccountsPayableMenuAnchor] = useState(null);
const [creditTermMenuAnchor, setCreditTermMenuAnchor] = useState(null);
const [pendingTransactionsMenuAnchor, setPendingTransactionsMenuAnchor] = useState(null);
const [paymentSummaryMenuAnchor, setPaymentSummaryMenuAnchor] = useState(null);
const [outStandingQueriesMenuAnchor, setOutStandingQueriesMenuAnchor] = useState(null);
const [purchaseOrderMenuAnchor, setPurchaseOrderMenuAnchor] = useState(null);
const [invoiceMenuAnchor, setInvoiceMenuAnchor] = useState(null);







  return (
    <>
      <div
        style={{
          backgroundColor: "#eee",
          minHeight: "inherit",
          padding: "8px",
          paddingTop: "16px",
          boxSizing: "border-box" // Prevent overflow
        }}
      >
             {/* Loader overlay with blur */}
        {loading && (
          <div
            aria-hidden={!loading}
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 1400,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255,255,255,0.35)", // light veil so backdrop-filter shows
              backdropFilter: "blur(6px)",
              WebkitBackdropFilter: "blur(6px)", // Safari
            }}
          >
        <div style={{ textAlign: "center" }}>
  <CircularProgress sx={{ color: "#009FE3" }} />
  <div style={{ marginTop: 12, color: "#009FE3", fontWeight: 500 }}>
    Loading
  </div>
</div>

          </div>
        )}
        <Grid
          container
          spacing={2}
          sx={{marginBottom: 2,px: { xs: 2, sm: 4, md: 4},}}
        >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}> 
            <Card sx={{ 
              overflow: "hidden", // Prevent content overflow
              margin: "0 auto" // Center the card
            }}>
              <CardContent
              sx={{ 
              p: { xs: 1.5, sm: 2, md: 3 }, // More controlled padding
              "&:last-child": { pb: { xs: 1.5, sm: 2, md: 3 } } // Fix bottom padding issue
            }}>
                <Grid container spacing={{ xs: 1.5, sm: 2, md: 3 }} alignItems="flex-end"> {/* Tighter spacing on mobile */}             
                  {/* Year */}
                  {/* <Grid item xs={12} sm={6} md={4}>
                    <Typography 
                      sx={{ 
                      fontSize: { xs: "14px", sm: "16px" },
                      fontWeight: 500,
                       mb: 1
                     }}
                    >
                      Year
                    </Typography>
                    <Autocomplete
                      sx={{
                        "& .MuiInputBase-root": {
                          height: { xs: "36px", sm: "40px" },
                          textAlign: "center",
                          display: "flex",
                          alignItems: "center",
                        },
                        "& .MuiInputBase-input": {
                          marginTop: "-4px",
                          fontSize: { xs: "14px", sm: "15px" },
                        },
                      }}
                      id="year-select"
                      options={Validyears}
                      size="small"
                      name="year"
                      getOptionLabel={(option) => option.toString()}
                      onChange={(event, newValue) => {
                        changeHandler("year", newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                          placeholder="Select Year"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    />
                    {errorMessage?.yearError && (
                      <Grid container spacing={0} 
                      sx={{ 
                        mt: 0.5,
                        alignItems: "center"
                      }}
                    >
                        <Grid item>
                          <Error
                            titleAccess="Error"
                            className={classes.asterisk}
                            fontSize="small"
                          />
                        </Grid>
                        <Grid item>
                          <Typography className={classes.asterisk} 
                          sx={{ 
                            ml: 1,
                            fontSize: { xs: "12px", sm: "14px" } // Responsive error text
                          }}
                        >
                            {errorMessage?.yearError}
                          </Typography>
                        </Grid>
                      </Grid>
                    )}
                  </Grid> */}

                  {/* Month */}
                  {/* <Grid item xs={12} sm={6} md={4}>
                    <Typography 
                    sx={{ 
                      fontSize: { xs: "14px", sm: "16px" },
                      fontWeight: 500,
                      mb: 1
                    }}
                  >
                    Month
                  </Typography>
                    <Autocomplete
                      sx={{
                        "& .MuiInputBase-root": {
                          height: { xs: "36px", sm: "40px" },
                          textAlign: "center",
                          display: "flex",
                          alignItems: "center",
                        },
                        "& .MuiInputBase-input": {
                          marginTop: "-4px",
                      fontSize: { xs: "14px", sm: "15px" },
                        },
                      }}
                      options={monthOptions}
                      disabled={!filter?.year}
                      size="small"
                      name="month"
                      value={
                        monthOptions.find(
                          (option) => option.value === filter?.month
                        ) || null
                      }
                      getOptionLabel={(option) => option?.label || ""}
                      isOptionEqualToValue={(option, value) =>
                        option?.value === value
                      }
                      onChange={(event, newValue) => {
                        changeHandler("month", newValue?.value || "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                        placeholder="Select Month"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    />
                    {errorMessage?.monthError && (
                      <Grid 
                      container 
                      spacing={0} 
                      sx={{ 
                        mt: 0.5,
                        alignItems: "center"
                      }}
                    >
                        <Grid item>
                          <Error
                            titleAccess="Error"
                            className={classes.asterisk}
                            fontSize="small"
                          />
                        </Grid>
                        <Grid item>
                          <Typography 
                          className={classes.asterisk} 
                          sx={{ 
                            ml: 1,
                            fontSize: { xs: "12px", sm: "14px" }
                          }}
                        >
                            {errorMessage?.monthError}
                          </Typography>
                        </Grid>
                      </Grid>
                    )}
                  </Grid> */}
 <Grid item xs={12} sm={6} md={4}>
          <Typography>
            Start Date:
          </Typography>
          <TextField
            type="date"
            variant="outlined"
            fullWidth
            size="small"
            value={filter?.startDate || ""}
            onChange={(e) => {
              changeHandler("startDate", e.target.value);
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          {errorMessage?.startDateError && (
            <Grid container spacing={0} sx={{ mt: 0.5, alignItems: "center" }}>
              <Grid item>
                <Error
                  titleAccess="Error"
                  className={classes.asterisk}
                  fontSize="small"
                />
              </Grid>
              <Grid item>
                <Typography
                  className={classes.asterisk}
                  sx={{
                    ml: 1,
                    fontSize: { xs: "12px", sm: "14px" },
                  }}
                >
                  {errorMessage?.startDateError}
                </Typography>
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography>
            End Date:
          </Typography>
          <TextField
            fullWidth
            size="small"
            type="date"
            variant="outlined"
            value={filter?.endDate || ""}
            onChange={(e) => {
              changeHandler("endDate", e.target.value);
            }}
            InputLabelProps={{
              shrink: true,
            }}
            style={{ marginRight: "10px" }}
          />
          {errorMessage?.endDateError && (
            <Grid container spacing={0} sx={{ mt: 0.5, alignItems: "center" }}>
              <Grid item>
                <Error
                  titleAccess="Error"
                  className={classes.asterisk}
                  fontSize="small"
                />
              </Grid>
              <Grid item>
                <Typography
                  className={classes.asterisk}
                  sx={{
                    ml: 1,
                    fontSize: { xs: "12px", sm: "14px" },
                  }}
                >
                  {errorMessage?.endDateError}
                </Typography>
              </Grid>
            </Grid>
          )}
        </Grid>
                  {/* Button */}
                  <Grid item xs={12} sm={12} md={2}>
                    <Button
                      fullWidth
                      sx={{
                        height: { xs: "36px", sm: "40px" }, // Responsive button height
                        color: "white",
                        backgroundColor: "rgb(0, 149, 218)",
                      fontSize: { xs: "14px", sm: "16px" }, // Responsive font size
                      fontWeight: 500,
                      "&:hover": {
                        backgroundColor: "rgb(0, 130, 190)",
                      },
                      mt: { xs: 1, md: 0 } // Add margin top on mobile, none on desktop
                      }}
                      variant="contained"
                      color="secondary"
                      type="submit"
                      id="proceed"
                      onClick={filterHandler}
                    >
                      Filter
                    </Button>
                  </Grid>
                     <Grid item xs={12} sm={12} md={2}>
                    <Button
                      fullWidth
                      sx={{
                        height: { xs: "36px", sm: "40px" }, // Responsive button height
                        color: "white",
                        backgroundColor: "rgb(12, 138, 37)",
                      fontSize: { xs: "14px", sm: "16px" }, // Responsive font size
                      fontWeight: 500,
                      "&:hover": {
                        backgroundColor: "rgb(21, 113, 39)",
                      },
                      mt: { xs: 1, md: 0 } // Add margin top on mobile, none on desktop
                      }}
                      variant="contained"
                      color="secondary"
                      type="button"
                      id="proceed"
                      onClick={openGuideInNewTab}
                    >
                      Guide
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Grid item  sx={{ marginTop: "50px" }} xs={12} sm={12} md={12} lg={12} xl={12}>
            <Card id="invoiceSummaryCard"
              sx={{
                position: "relative",
                overflow: "visible",
                paddingTop: "30px",
                textAlign: "right",
                backGround: "transparent",
                boxShadow: "none",
                minHeight:"inherit"
              }}
            >
              <Box className="hide-on-download" 
                sx={{
                  background: "linear-gradient(60deg, #66bb6a, #43a047)",
                  boxShadow:
                    "0 4px 20px 0 rgba(0, 0, 0, .14), 0 7px 10px -5px rgba(67, 160, 71, .4)",
                  position: "absolute",
                  top: "-35px", // pushes icon box half above card
                  left: "16px",
                  borderRadius: "10px",
                  padding: "10",
                  width: "80px",
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1,
                }}
                display="flex"
                justifyContent="left"
                mb={1}
              >
                <Summarize sx={{ color: "#fff", fontSize: "60px" }} />
              </Box>
              <CardHeader
                sx={{
                  marginTop: "-30px",
                  paddingLeft: "100px",
                }}
                titleTypographyProps={{ fontWeight: "bold", fontSize: "24px", 
                minHeight: "48px",
                lineHeight: "24px", }}
                title="Invoices Summary"
                action={
                  <>
                    {/* Expand/Collapse button */}
                    <IconButton onClick={() => setInvoicesSummaryExpanded(prev => !prev)}>
                      {invoicesSummaryExpanded ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>

                    {/* 3-dot menu */}
                    {invoicesSummaryExpanded &&
                    <IconButton className="hide-on-download" onClick={(e) => setAnchorEl(e.currentTarget)}>
                      <MoreVertIcon />
                    </IconButton>}
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={() => setAnchorEl(null)}
                    >
                      <MenuItem
                        onClick={() => {
                          handleDownload("invoiceSummaryCard", "pdf", "Invoices_Summary");
                          setAnchorEl(null);
                        }}
                      >
                        <PictureAsPdfIcon sx={{ mr: 1 }} /> Download PDF
                      </MenuItem>
                      {/* <MenuItem
                        onClick={() => {
                          handleDownload("invoiceSummaryCard", "excel", "Invoices_Summary");
                          setAnchorEl(null);
                        }}
                      >
                        <InsertDriveFileIcon sx={{ mr: 1 }} /> Download Excel
                      </MenuItem> */}
                    </Menu>
                  </>
                }
              />
              <Collapse in={invoicesSummaryExpanded} timeout="auto">
                <CardContent>
                  <DashboardAccountPayableCounts PayableCountsList={PayableCountsList} />
                </CardContent>
              </Collapse>
            </Card>
          </Grid>

<Grid container spacing={2}  >
  {/* Card 1 - Invoices received */}
  {/* <Grid item  sx={{marginTop:"20px"}} xs={12} sm={12} md={6} lg={4} xl={4}>
            <Card
              sx={{
                position: "relative",
                overflow: "visible",
                paddingTop: "30px",
                textAlign: "right",
                backGround: "transparent",
                boxShadow: "none",
                minHeight:"inherit"
              }}
            >
              <Box
                sx={{
                  background: "linear-gradient(60deg, #ffa726, #fb8c00)",
                  boxShadow:
                    "0 4px 20px 0 rgba(0, 0, 0, .14), 0 7px 10px -5px rgba(255, 152, 0, .4)",
                  position: "absolute",
                  top: "-35px", // pushes icon box half above card
                  left: "16px",
                  borderRadius: "10px",
                  padding: "10",
                  width: "80px",
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1,
                }}
                display="flex"
                justifyContent="left"
                mb={1}
              >
                <ReceiptLong sx={{ color: "#fff", fontSize: "60px" }} />
              </Box>
              <CardHeader
                sx={{
                  marginTop: "-30px",
                  paddingLeft: "100px",
                }}
                titleTypographyProps={{ fontWeight: "bold", fontSize: "24px",  
                minHeight: "48px", 
                lineHeight: "24px", }}
                title="Invoices received"
                action={
                  <IconButton
                    onClick={() => {
                      setInvoiceRecievedExpanded((prev) => !prev);
                    }}
                  >
                    {invoiceRecievedExpanded ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                }
              />
              <Collapse in={invoiceRecievedExpanded} timeout="auto" unmountOnExit>
                <CardContent>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 300 }} aria-label="PO Table">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ width: "40%" }}></TableCell>
                          <TableCell sx={{ width: "30%" }}>
                            <b>PO</b>
                          </TableCell>
                          <TableCell sx={{ width: "30%" }}>
                            <b>NON PO</b>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell>
                            <b>No. of invoice</b>
                          </TableCell>
                          <TableCell>{FormatAmount(PayableCountsList?.invoicesRecievedPO || 0)}</TableCell>
                          <TableCell>{FormatAmount(PayableCountsList?.invoicesRecievedNonPO || 0)}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <b>Amount</b>
                          </TableCell>
                          <TableCell>{FormatAmount(PayableCountsList?.invRecievedPOAmount || 0)}</TableCell>
                          <TableCell>{FormatAmount(PayableCountsList?.invRecievedNonPOAmount || 0)}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Collapse>
            </Card>
          </Grid> */}
      
          {/* Card 2 - Invoices processed */}
          {/* <Grid item sx={{ marginTop: "20px" }} xs={12} sm={12} md={6} lg={4} xl={4}>
            <Card
              sx={{
                position: "relative",
                overflow: "visible",
                paddingTop: "30px",
                textAlign: "right",
                backGround: "transparent",
                boxShadow: "none",
                minHeight:"inherit"
              }}
            >
              <Box
                sx={{
                  background: "linear-gradient(60deg, #66bb6a, #43a047)",
                  boxShadow: "0 4px 20px 0 rgba(0, 0, 0, .14), 0 7px 10px -5px rgba(76, 175, 80, .4)",
                  position: "absolute",
                  top: "-35px", // pushes icon box half above card
                  left: "16px",
                  borderRadius: "10px",
                  padding: "10",
                  width: "80px",
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1,
                }}
                display="flex"
                justifyContent="left"
                mb={1}
              >
                <AssignmentTurnedIn sx={{ color: "#fff", fontSize: "60px" }} />
              </Box>
              <CardHeader
                sx={{
                  marginTop: "-30px",
                  paddingLeft: "100px",
                }}
                titleTypographyProps={{ fontWeight: "bold", fontSize: "24px",
                 minHeight: "48px",
                 lineHeight: "24px", }}
                title="Invoices processed"
                action={
                  <IconButton
                    onClick={() => {
                      setInvoiceProcessedExpanded((prev) => !prev);
                    }}
                  >
                    {invoiceProcessedExpanded ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                }
              />
              <Collapse in={invoiceProcessedExpanded} timeout="auto" unmountOnExit>
                <CardContent>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 300 }} aria-label="PO Table">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ width: "40%" }}></TableCell>
                          <TableCell sx={{ width: "30%" }}>
                            <b>PO</b>
                          </TableCell>
                          <TableCell sx={{ width: "30%" }}>
                            <b>NON PO</b>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell>
                            <b>No. of invoice</b>
                          </TableCell>
                          <TableCell>{FormatAmount(PayableCountsList?.invoicesProcessedPO || 0)}</TableCell>
                          <TableCell>{FormatAmount(PayableCountsList?.invoicesProcessedNonPO || 0)}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <b>Amount</b>
                          </TableCell>
                          <TableCell>{FormatAmount(PayableCountsList?.invProcessedPOAmount || 0)}</TableCell>
                          <TableCell>{FormatAmount(PayableCountsList?.invProcessedNonPOAmount || 0)}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Collapse>
            </Card>
          </Grid> */}
      
             {/* Card 3 - Invoices in process */}
          {/* <Grid item sx={{ marginTop: "20px" }} xs={12} sm={12} md={6} lg={4} xl={4}>
            <Card
              sx={{
                position: "relative",
                overflow: "visible",
                paddingTop: "30px",
                textAlign: "right",
                backGround: "transparent",
                boxShadow: "none",
                minHeight:"inherit"
              }}
            >
              <Box
                sx={{
                  background: "linear-gradient(60deg, #ef5350, #e53935)",
                  boxShadow: " 0 4px 20px 0 rgba(0, 0, 0, .14), 0 7px 10px -5px rgba(244, 67, 54, .4)",
                  position: "absolute",
                  top: "-35px", // pushes icon box half above card
                  left: "16px",
                  borderRadius: "10px",
                  padding: "10",
                  width: "80px",
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1,
                }}
                display="flex"
                justifyContent="left"
                mb={1}
              >
                <Autorenew sx={{ color: "#fff", fontSize: "60px" }} />
              </Box>
              <CardHeader
                sx={{
                  marginTop: "-30px",
                 paddingLeft: "100px",
                }}
                titleTypographyProps={{ fontWeight: "bold", fontSize: "24px", 
                     minHeight: "48px", 
                     lineHeight: "24px",}}
                title="Invoices in process"
                action={
                  <IconButton
                    onClick={() => {
                      setInvoiceInProcessExpanded((prev) => !prev);
                    }}
                  >
                    {invoiceInProcessExpanded ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                }
              />
              <Collapse in={invoiceInProcessExpanded} timeout="auto" unmountOnExit>
                <CardContent>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 300 }} aria-label="PO Table">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ width: "40%" }}></TableCell>
                          <TableCell sx={{ width: "30%" }}>
                            <b>PO</b>
                          </TableCell>
                          <TableCell sx={{ width: "30%" }}>
                            <b>NON PO</b>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                     <TableBody>
                        <TableRow>
                          <TableCell>
                            <b>No. of invoice</b>
                          </TableCell>
                          <TableCell>{FormatAmount(PayableCountsList?.invoicesInProcessPO || 0)}</TableCell>
                          <TableCell>{FormatAmount(PayableCountsList?.invoicesInProcessNonPO || 0)}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <b>Amount</b>
                          </TableCell>
                          <TableCell>{FormatAmount(PayableCountsList?.invInProcessPOAmount || 0)}</TableCell>
                          <TableCell>{FormatAmount(PayableCountsList?.invInProcessNonPOAmount || 0)}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Collapse>
            </Card>
          </Grid> */}

  {/* Card 4 - Pre-Payment/ VF */}
          <Grid item sx={{marginTop:"20px"}} xs={12} sm={12} md={6} lg={4} xl={4} > 
            <Card 
              id="vendorFinancingCard" // ✅ Add this ID
              sx={{
                position: "relative",
                overflow: "visible",
                paddingTop: "30px",
                textAlign: "right",
                backGround: "transparent",
                boxShadow: "none",
                minHeight:"inherit"
              }}
            >
              <Box
                className="hide-on-download" // ✅ Add this class
                sx={{
                  background: "linear-gradient(60deg, #26c6da, #00acc1)",
                  boxShadow: "0 4px 20px 0 rgba(0, 0, 0, .14), 0 7px 10px -5px rgba(0, 172, 193, .4)",
                  position: "absolute",
                  top: "-35px", // pushes icon box half above card
                  left: "16px",
                  borderRadius: "10px",
                  padding: "10",
                  width: "80px",
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1,
                }}
                display="flex"
                justifyContent="left"
                mb={1}
              >
                <AccountBalance sx={{ color: "#fff", fontSize: "60px" }} />
              </Box>
              <CardHeader
                sx={{
                  marginTop: "-30px",
                  paddingLeft: "100px",
                }}
                titleTypographyProps={{ fontWeight: "bold", fontSize: "24px",  
                 minHeight: "48px",
                 lineHeight: "24px", }}
                title="Vendor Financing"
                action={
                  <>
                  <IconButton
                    onClick={() => {
                      setPrePaymentExpanded((prev) => !prev);
                    }}
                    >
                      {prePaymentExpanded ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>
                    {prePaymentExpanded &&
                      <IconButton className="hide-on-download" onClick={(e) => setVendorMenuAnchor(e.currentTarget)}>
                        <MoreVertIcon />
                      </IconButton>
                    }
                    <Menu
                      anchorEl={vendorMenuAnchor}
                      open={Boolean(vendorMenuAnchor)}
                      onClose={() => setVendorMenuAnchor(null)}
                    >
                      <MenuItem
                        onClick={() => {
                          handleDownload("vendorFinancingCard", "pdf", "Vendor_Financing");
                          setVendorMenuAnchor(null);
                        }}
                      >
                        <PictureAsPdfIcon sx={{ mr: 1 }} /> Download PDF
                      </MenuItem>

                      {/* <MenuItem
                        onClick={() => {
                          handleDownload("vendorFinancingCard", "excel", "Vendor_Financing");
                          setVendorMenuAnchor(null);
                        }}
                      >
                        <InsertDriveFileIcon sx={{ mr: 1 }} /> Download Excel
                      </MenuItem> */}
                    </Menu>

                  </>}
              />
              <Collapse in={prePaymentExpanded} timeout="auto" unmountOnExit>
                <CardContent>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 300 }} aria-label="PO Table">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ width: "50%" }}><b>No of Batches</b></TableCell>
                          <TableCell align="right">
                            {FormatAmount(dashboardStats?.vendorFinancing_PP || 0)}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell>
                            <b>No. of invoices</b>
                          </TableCell>
                          <TableCell align="right">
                            {FormatAmount(dashboardStats?.vendorFinancing_Invoice || 0)}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <b>Amount</b>
                          </TableCell>
                          <TableCell align="right">
                            {FormatAmount(dashboardStats?.vF_PPAmount || 0)}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Collapse>
            </Card>
          </Grid>
          {/* Card 5 - Shipment payments */}
          <Grid item sx={{ marginTop: "20px" }} xs={12} sm={12} md={6} lg={4} xl={4} >
           <Card id="shippingPaymentsCard"
              sx={{
                position: "relative",
                overflow: "visible",
                paddingTop: "30px",
                textAlign: "right",
                backGround: "transparent",
                boxShadow: "none",
                minHeight:"inherit"
              }}
            >
              <Box
                className="hide-on-download" // ✅ Add this class
                sx={{
                  background: "linear-gradient(60deg, #ab47bc, #8e24aa)",
                  boxShadow: "0 4px 20px 0 rgba(0, 0, 0, .14), 0 7px 10px -5px rgba(156, 39, 176, .4)",
                  position: "absolute",
                  top: "-35px", // pushes icon box half above card
                  left: "16px",
                  borderRadius: "10px",
                  padding: "10",
                  width: "80px",
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1,
                }}
                display="flex"
                justifyContent="left"
                mb={1}
              >
                <Payments sx={{ color: "#fff", fontSize: "60px" }} />
              </Box>
              <CardHeader
                sx={{
                  marginTop: "-30px",
                  paddingLeft: "100px",
                }}
                titleTypographyProps={{ fontWeight: "bold", fontSize: "24px",  
                 minHeight: "48px", 
                lineHeight: "24px", }}
                title="Shipping payments"
                action={
                <>
                  <IconButton
                    onClick={() => {
                      setShipmentPaymentExpanded((prev) => !prev);
                    }}
                  >
                    {shipmentPaymentExpanded ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                    {/* 3-dot download menu */}
                    {shipmentPaymentExpanded &&
                      <IconButton className="hide-on-download" onClick={(e) => setShippingMenuAnchor(e.currentTarget)}>
                        <MoreVertIcon />
                      </IconButton>}
                    <Menu
                      anchorEl={shippingMenuAnchor}
                      open={Boolean(shippingMenuAnchor)}
                      onClose={() => setShippingMenuAnchor(null)}
                    >
                      <MenuItem
                        onClick={() => {
                          handleDownload("shippingPaymentsCard", "pdf", "Shipping_Payments");
                          setShippingMenuAnchor(null);
                        }}
                      >
                        <PictureAsPdfIcon sx={{ mr: 1 }} /> Download PDF
                      </MenuItem>

                      {/* <MenuItem
                        onClick={() => {
                          handleDownload("shippingPaymentsCard", "excel", "Shipping_Payments");
                          setShippingMenuAnchor(null);
                        }}
                      >
                        <InsertDriveFileIcon sx={{ mr: 1 }} /> Download Excel
                      </MenuItem> */}
                    </Menu>

                  </>}
              />
              <Collapse in={shipmentPaymentExpanded} timeout="auto" unmountOnExit>
                <CardContent>
                  <TableContainer component={Paper} sx={{ mb: 6.5 }}>
                    <Table sx={{ minWidth: 300 }} aria-label="PO Table">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ width: "50%" }}>
                            <b>No. of invoices</b>
                          </TableCell>
                          <TableCell sx={{ width: "30%" }} align="right">
                            {FormatAmount(dashboardStats?.shippingPayments || 0)}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell>
                            <b>Amount</b>
                          </TableCell>
                          <TableCell align="right">
                            {FormatAmount(dashboardStats?.spAmount || 0)}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Collapse>
            </Card>
          </Grid>
          {/* Card 6 - Cheque Made */}
          <Grid item sx={{ marginTop: "20px"}} xs={12} sm={12} md={6} lg={4} xl={4}>
            <Card
            id="chequeMadeCard"
              sx={{
                position: "relative",
                overflow: "visible",
                paddingTop: "30px",
                textAlign: "right",
                backGround: "transparent",
                boxShadow: "none",
                minHeight:"inherit"
              }}
            >
              <Box className="hide-on-download" 
                sx={{
                  background: "linear-gradient(60deg, #ffa726, #fb8c00)",
                  boxShadow:
                    "0 4px 20px 0 rgba(0, 0, 0, .14), 0 7px 10px -5px rgba(255, 152, 0, .4)",
                  position: "absolute",
                  top: "-35px", // pushes icon box half above card
                  left: "16px",
                  borderRadius: "10px",
                  padding: "10",
                  width: "80px",
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1,
                }}
                display="flex"
                justifyContent="left"
                mb={1}
              >
                <RequestQuote sx={{ color: "#fff", fontSize: "60px" }} />
              </Box>
              <CardHeader
                sx={{
                  marginTop: "-30px",
                  paddingLeft: "100px",
                }}
                titleTypographyProps={{ fontWeight: "bold", fontSize: "24px",  
                  minHeight: "48px",
                 lineHeight: "24px", }}
                title="Cheque Details"
                action={
                  <>
                    <IconButton
                      onClick={() => {
                        setChequeMadeExpanded((prev) => !prev);
                      }}
                    >
                      {chequeMadeExpanded ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>

                    {/* 3-dot download menu — show only when expanded */}
                    {chequeMadeExpanded && (
                      <IconButton className="hide-on-download" onClick={(e) => setChequeMenuAnchor(e.currentTarget)}>
                        <MoreVertIcon />
                      </IconButton>
                    )}

                    <Menu
                      anchorEl={chequeMenuAnchor}
                      open={Boolean(chequeMenuAnchor)}
                      onClose={() => setChequeMenuAnchor(null)}
                    >
                      <MenuItem
                        onClick={() => {
                          handleDownload("chequeMadeCard", "pdf", "Cheque_Made");
                          setChequeMenuAnchor(null);
                        }}
                      >
                        <PictureAsPdfIcon sx={{ mr: 1 }} /> Download PDF
                      </MenuItem>

                      {/* <MenuItem
                        onClick={() => {
                          handleDownload("chequeMadeCard", "excel", "Cheque_Made");
                          setChequeMenuAnchor(null);
                        }}
                      >
                        <InsertDriveFileIcon sx={{ mr: 1 }} /> Download Excel
                      </MenuItem> */}
                    </Menu>
                  </>
                }
              />
              <Collapse in={chequeMadeExpanded} timeout="auto" unmountOnExit>
                <CardContent sx={{ mb: 12 }}>
                  <h2>Coming soon</h2>
                  {/* <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 300 }} aria-label="PO Table">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ width: "40%" }}></TableCell>
                          <TableCell sx={{ width: "30%" }}>
                            <b>PO</b>
                          </TableCell>
                          <TableCell sx={{ width: "30%" }}>
                            <b>NON PO</b>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell>
                            <b>No. of invoice</b>
                          </TableCell>
                          <TableCell>322</TableCell>
                          <TableCell>12</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <b>Amount</b>
                          </TableCell>
                          <TableCell>1211</TableCell>
                          <TableCell>22122</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer> */}
                </CardContent>
              </Collapse>
            </Card>
          </Grid>
        </Grid>



         <Grid container spacing={2} sx={{marginTop:"5px"}}>
          {/* Card 1 */}

          <Grid item  sx={{marginTop:"20px" }}   xs={12} sm={12} md={12} lg={12} xl={12}>
            <Card  
            id="employeeClaimsCard"
              sx={{
                position: "relative",
                overflow: "visible",
                paddingTop: "30px",
                textAlign: "right",
                backGround: "transparent",
                boxShadow: "none",
                minHeight:"inherit"
              }}
            >
              <Box className="hide-on-download" 
                sx={{
                  background: "linear-gradient(60deg, #66bb6a, #43a047)",
                  boxShadow: "0 4px 20px 0 rgba(0, 0, 0, .14), 0 7px 10px -5px rgba(76, 175, 80, .4)",
                  position: "absolute",
                  top: "-35px", // pushes icon box half above card
                  left: "16px",
                  borderRadius: "10px",
                  padding: "10",
                  width: "80px",
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1,
                }}
                display="flex"
                justifyContent="left"
                mb={1}
              >
                <AssignmentTurnedIn sx={{ color: "#fff", fontSize: "60px" }} />
              </Box>
              <CardHeader
                sx={{
                  marginTop: "-30px",
                  paddingLeft: "100px",
                }}
                titleTypographyProps={{ fontWeight: "bold", fontSize: "24px",
                minHeight: "48px", 
                lineHeight: "24px", }}
                title="Employee Claims/Reimbursement"
                action={
                  <>
                    {/* Collapse button */}
                    <IconButton
                      onClick={() => {
                        setEmployeeClaimExpanded((prev) => !prev);
                      }}
                    >
                      {employeeClaimExpanded ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>

                    {/* 3-dot download menu (only visible when expanded) */}
                    {employeeClaimExpanded && (
                      <IconButton className="hide-on-download" onClick={(e) => setEmployeeMenuAnchor(e.currentTarget)}>
                        <MoreVertIcon />
                      </IconButton>
                    )}

                    <Menu
                      anchorEl={employeeMenuAnchor}
                      open={Boolean(employeeMenuAnchor)}
                      onClose={() => setEmployeeMenuAnchor(null)}
                    >
                      <MenuItem
                        onClick={() => {
                          handleDownload("employeeClaimsCard", "pdf", "Employee_Claims_Reimbursement");
                          setEmployeeMenuAnchor(null);
                        }}
                      >
                        <PictureAsPdfIcon sx={{ mr: 1 }} /> Download PDF
                      </MenuItem>
                      {/* <MenuItem
                        onClick={() => {
                          handleDownload("employeeClaimsCard", "excel", "Employee_Claims_Reimbursement");
                          setEmployeeMenuAnchor(null);
                        }}
                      >
                        <InsertDriveFileIcon sx={{ mr: 1 }} /> Download Excel
                      </MenuItem> */}
                    </Menu>
                  </>
                }
              />
              <Collapse in={employeeClaimExpanded} timeout="auto" unmountOnExit>
                <CardContent>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 300 }} aria-label="PO Table">
                      <TableHead>
                        <TableRow>
                         <TableCell sx={{  width: "12.5%" }}></TableCell>

                          <TableCell sx={{ width: "12.5%" }} align="right">
                            <b>ERF</b>
                          </TableCell>

                          <TableCell sx={{ width: "12.5%" }} align="right">
                            <b>MRF</b>
                          </TableCell>

                          <TableCell sx={{ width: "12.5%" }} align="right">
                            <b>FER</b>
                          </TableCell>

                          <TableCell sx={{ width: "12.5%" }} align="right">
                            <b>ARF</b>
                          </TableCell>

                          <TableCell sx={{ width: "12.5%" }} align="right">
                            <b>EFDV</b>
                          </TableCell>

                          <TableCell sx={{ width: "12.5%" }} align="right">
                            <b>HR</b>
                          </TableCell>
                           <TableCell sx={{ width: "12.5%" }} align="right">
                            <b>TOTAL</b>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell>
                            <b>No. of invoices</b>
                          </TableCell>
                          <TableCell align="right">{FormatAmount(dashboardStats?.erf || 0)}</TableCell>
                          <TableCell align="right">{FormatAmount(dashboardStats?.mrf || 0)}</TableCell>
                          <TableCell align="right">{FormatAmount(dashboardStats?.fer || 0)}</TableCell>
                          <TableCell align="right">{FormatAmount(dashboardStats?.arf || 0)}</TableCell>
                          <TableCell align="right">{FormatAmount(dashboardStats?.efdv || 0)}</TableCell>
                          <TableCell align="right">{FormatAmount(dashboardStats?.other || 0)}</TableCell>
                          <TableCell align="right">{FormatAmount(dashboardStats?.total || 0)}</TableCell>

                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <b>Amount</b>
                          </TableCell>
                          <TableCell align="right">{FormatAmount(dashboardStats?.erfAmount || 0)}</TableCell>
                          <TableCell align="right">{FormatAmount(dashboardStats?.mrfAmount || 0)}</TableCell>
                          <TableCell align="right">{FormatAmount(dashboardStats?.ferAmount || 0)}</TableCell>
                          <TableCell align="right">{FormatAmount(dashboardStats?.arfAmount || 0)}</TableCell>
                          <TableCell align="right">{FormatAmount(dashboardStats?.efdvAmount || 0)}</TableCell>
                          <TableCell align="right">{FormatAmount(dashboardStats?.otherAmount || 0)}</TableCell>
                          <TableCell align="right">{FormatAmount(dashboardStats?.totalAmount || 0)}</TableCell>

                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Collapse>
            </Card>
          </Grid>
      
     


        </Grid>


   <Grid container  spacing={2} sx={{marginTop:"5px"}}>
          {/* Card 1 */}

          <Grid item  sx={{marginTop:"20px" }}  xs={12} sm={12} md={12} lg={6} xl={6} >
            <Card
              id="accountsPayableCard"
              sx={{
                position: "relative",
                overflow: "visible",
                paddingTop: "30px",
                textAlign: "right",
                backGround: "transparent",
                boxShadow: "none",
                minHeight: "inherit"
              }}
            >
              <Box
              className="hide-on-download" 
                sx={{
                  background: "linear-gradient(60deg, #7b1fa2, #6a1b9a)",
                  boxShadow:
                    "0 4px 20px 0 rgba(0, 0, 0, .14), 0 7px 10px -5px rgba(123, 31, 162, .4)",
                  position: "absolute",
                  top: "-35px", // pushes icon box half above card
                  left: "16px",
                  borderRadius: "10px",
                  padding: "10",
                  width: "80px",
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1,
                }}
                display="flex"
                justifyContent="left"
                mb={1}
              >
                <Assessment sx={{ color: "#fff", fontSize: "60px" }} />
              </Box>
              <CardHeader
                sx={{
                  marginTop: "-30px",
                  paddingLeft: "100px",
                }}
                titleTypographyProps={{ fontWeight: "bold", fontSize: "24px",  
                minHeight: "48px",  
                lineHeight: "24px", }}
                title="Accounts Payable Overview"
                action={
                  <>
                    {/* Expand Button */}
                    <IconButton
                      onClick={() => {
                        setAccountPayableExpanded((prev) => !prev);
                      }}
                    >
                      {accountPayableExpanded ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>

                    {/* 3-dot menu only when expanded */}
                    {accountPayableExpanded && (
                      <IconButton
                        onClick={(e) => setAccountsPayableMenuAnchor(e.currentTarget)}
                        className="hide-on-download"
                      >
                        <MoreVertIcon />
                      </IconButton>
                    )}

                    <Menu
                      anchorEl={accountsPayableMenuAnchor}
                      open={Boolean(accountsPayableMenuAnchor)}
                      onClose={() => setAccountsPayableMenuAnchor(null)}
                    >
                      <MenuItem
                        onClick={() => {
                          handleDownload("accountsPayableCard", "pdf", "Accounts_Payable_Overview");
                          setAccountsPayableMenuAnchor(null);
                        }}
                      >
                        <PictureAsPdfIcon sx={{ mr: 1 }} /> Download PDF
                      </MenuItem>

                      {/* <MenuItem
                        onClick={() => {
                          handleDownload("accountsPayableCard", "excel", "Accounts_Payable_Overview");
                          setAccountsPayableMenuAnchor(null);
                        }}
                      >
                        <InsertDriveFileIcon sx={{ mr: 1 }} /> Download Excel
                      </MenuItem> */}
                    </Menu>
                  </>
                }
              />
              <Collapse in={accountPayableExpanded} timeout="auto" >
                <CardContent >
                  <TableContainer component={Paper} sx={{  maxHeight: 430, overflowY: "auto"}}>
                    <Table  sx={{ minWidth: 300}} aria-label="PO Table" stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ width: "40%" }}>
                            <b>Name</b>
                          </TableCell>
                          <TableCell sx={{ width: "15%" }} align="right">
                            <b>Today</b>
                          </TableCell>
                          <TableCell sx={{ width: "15%" }} align="right">
                            <b>MTD</b>
                          </TableCell>
                          <TableCell sx={{ width: "15%" }} align="right">
                            <b>YTD</b>
                          </TableCell>
                              <TableCell sx={{ width: "15%" }} align="right">
                            <b>SELECTED DATE DATA</b>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {loading ? (
                          Array.from(new Array(5)).map((_, index) => (
                            <TableRow key={index}>
                              <TableCell><Skeleton height={30} /></TableCell>
                              <TableCell><Skeleton height={30} /></TableCell>
                              <TableCell><Skeleton height={30} /></TableCell>
                              <TableCell><Skeleton height={30} /></TableCell>
                              <TableCell><Skeleton height={30} /></TableCell>
                            </TableRow>
                          ))
                        ) : (
                          listPayable.map((row, idx) => (
                            <TableRow key={idx}>
                              <TableCell><b>{row.name || ""}</b></TableCell>
                              <TableCell align="right">{FormatAmount(row.today ?? 0)}</TableCell>
                              <TableCell align="right">{FormatAmount(row.mtd ?? 0)}</TableCell>
                              <TableCell align="right">{FormatAmount(row.ytd ?? 0)}</TableCell>
                              <TableCell align="right">{FormatAmount(row.total ?? 0)}</TableCell>
                            </TableRow>
                          ))
                        )}

        </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Collapse>
            </Card>
          </Grid>
          <Grid item  sx={{marginTop:"20px"}}  xs={12} sm={12} md={12} lg={6} xl={6} >
            <Card
             id="creditTermComplianceCard"
              sx={{
                position: "relative",
                overflow: "visible",
                paddingTop: "30px",
                textAlign: "right",
                backGround: "transparent",
                boxShadow: "none",
                minHeight:"inherit"
              }}
            >
              <Box
              className="hide-on-download" 
                sx={{
                  background: "linear-gradient(60deg, #26c6da, #00acc1)",
                  boxShadow:
                    "0 4px 20px 0 rgba(0, 0, 0, .14), 0 7px 10px -5px rgba(0, 172, 193, .4)",
                  position: "absolute",
                  top: "-35px", // pushes icon box half above card
                  left: "16px",
                  borderRadius: "10px",
                  padding: "10",
                  width: "80px",
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1,
                }}
                display="flex"
                justifyContent="left"
                mb={1}
              >
                <FactCheck sx={{ color: "#fff", fontSize: "60px" }} />
              </Box>
              <CardHeader
                sx={{
                  marginTop: "-30px",
                  paddingLeft: "100px",
                }}
                titleTypographyProps={{ fontWeight: "bold", fontSize: "24px",   
                 minHeight: "48px",
                 lineHeight: "24px", }}
                title="Credit Term Compliance Overview"
                action={
                  <>
                    {/* Expand/Collapse Button */}
                    <IconButton
                      onClick={() => {
                        setCreditTermComplainceExpanded((prev) => !prev);
                      }}
                    >
                      {creditTermComplainceExpanded ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>

                    {/* 3-dot menu - only when expanded */}
                    {creditTermComplainceExpanded && (
                      <IconButton
                        onClick={(e) => setCreditTermMenuAnchor(e.currentTarget)}
                        className="hide-on-download"
                      >
                        <MoreVertIcon />
                      </IconButton>
                    )}

                    <Menu
                      anchorEl={creditTermMenuAnchor}
                      open={Boolean(creditTermMenuAnchor)}
                      onClose={() => setCreditTermMenuAnchor(null)}
                    >
                      <MenuItem
                        onClick={() => {
                          handleDownload("creditTermComplianceCard", "pdf", "Credit_Term_Compliance");
                          setCreditTermMenuAnchor(null);
                        }}
                      >
                        <PictureAsPdfIcon sx={{ mr: 1 }} /> Download PDF
                      </MenuItem>

                      {/* <MenuItem
                        onClick={() => {
                          handleDownload("creditTermComplianceCard", "excel", "Credit_Term_Compliance");
                          setCreditTermMenuAnchor(null);
                        }}
                      >
                        <InsertDriveFileIcon sx={{ mr: 1 }} /> Download Excel
                      </MenuItem> */}
                    </Menu>
                  </>
                }
              />
              <Collapse in={creditTermComplainceExpanded} timeout="auto">
                <CardContent >
                  <TableContainer component={Paper} sx={{  maxHeight: 430, overflowY: "auto"}}>
                    <Table sx={{ minWidth: 300  }} aria-label="PO Table" stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ width: "40%" }}>
                            <b>Name</b>
                          </TableCell>
                          <TableCell sx={{ width: "15%" }} align="right">
                            <b>MTD</b>
                          </TableCell>
                          <TableCell sx={{ width: "15%" }} align="right">
                            <b>%age</b>
                          </TableCell>
                          <TableCell sx={{ width: "15%" }} align="right">
                            <b>YTD</b>
                          </TableCell>
                          <TableCell sx={{ width: "15%" }} align="right">
                            <b>%age</b>
                          </TableCell>
                              <TableCell sx={{ width: "15%" }} align="right">
                            <b>SELECTED DATE DATA</b>
                          </TableCell>
                              <TableCell sx={{ width: "15%" }} align="right">
                            <b>%age</b>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
            {complianceData.map((row, index) => (
                <TableRow
                    key={row.name}
                    // sx={{
                    //     '&:last-child td': {
                    //         fontWeight: index === complianceData.length - 1 ? 'bold' : 'normal',
                    //     },
                    // }}
                >
                    <TableCell >{row.name || ""}</TableCell>
                    <TableCell align="right">{FormatAmount(row.mtd ?? 0)}</TableCell>
                    <TableCell align="right">{`${FormatAmount(row.mtdPercentage ?? 0)}%`}</TableCell>
                    <TableCell align="right">{FormatAmount(row.ytd ?? 0)}</TableCell>
                    <TableCell align="right">{`${FormatAmount(row.ytdPercentage ?? 0)}%`}</TableCell>
                    <TableCell align="right">{`${FormatAmount(row.total ?? 0)}`}</TableCell>
                    <TableCell align="right">{`${FormatAmount(row.totalPercentage ?? 0)}%`}</TableCell>

                </TableRow>
            ))}
        </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Collapse>
            </Card>
          </Grid>
          </Grid>
        <Grid container spacing={2} sx={{ marginTop: "5px" }} >

          <Grid item sx={{ marginTop: "20px" }} xs={12} sm={12} md={12} lg={12} xl={12}  >
            <Card
                id="pendingTransactionsCard"
              sx={{
                position: "relative",
                overflow: "visible",
                paddingTop: "30px",
                textAlign: "right",
                backGround: "transparent",
                boxShadow: "none",
                minHeight:"inherit"
              }}
            >
              <Box
              className="hide-on-download" 
                sx={{
                  background: "linear-gradient(60deg, #ffa726, #fb8c00)",
                  boxShadow:
                    "0 4px 20px 0 rgba(0, 0, 0, .14), 0 7px 10px -5px rgba(251, 140, 0, .4)",
                  position: "absolute",
                  top: "-35px", // pushes icon box half above card
                  left: "16px",
                  borderRadius: "10px",
                  padding: "10",
                  width: "80px",
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1,
                }}
                display="flex"
                justifyContent="left"
                mb={1}
              >
                <PendingActions sx={{ color: "#fff", fontSize: "60px" }} />
              </Box>
              <CardHeader
                sx={{
                  marginTop: "-30px",
                  paddingLeft: "100px",
                }}
                titleTypographyProps={{ fontWeight: "bold", fontSize: "24px", 
                 minHeight: "48px",   
                 lineHeight: "24px", }}
                title="Overview of Pending Transactions"
                action={
                  <>
                    {/* Expand/Collapse Button */}
                    <IconButton
                      onClick={() => {
                        setOverViewExpanded((prev) => !prev);
                      }}
                    >
                      {overViewExpanded ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>

                    {/* 3-dot menu - only when expanded */}
                    {overViewExpanded && (
                      <IconButton
                        onClick={(e) => setPendingTransactionsMenuAnchor(e.currentTarget)}
                        className="hide-on-download"
                      >
                        <MoreVertIcon />
                      </IconButton>
                    )}

                    <Menu
                      anchorEl={pendingTransactionsMenuAnchor}
                      open={Boolean(pendingTransactionsMenuAnchor)}
                      onClose={() => setPendingTransactionsMenuAnchor(null)}
                    >
                      <MenuItem
                        onClick={() => {
                          handleDownload("pendingTransactionsCard", "pdf", "Pending_Transactions");
                          setPendingTransactionsMenuAnchor(null);
                        }}
                      >
                        <PictureAsPdfIcon sx={{ mr: 1 }} /> Download PDF
                      </MenuItem>

                      {/* <MenuItem
                        onClick={() => {
                          handleDownload("pendingTransactionsCard", "excel", "Pending_Transactions");
                          setPendingTransactionsMenuAnchor(null);
                        }}
                      >
                        <InsertDriveFileIcon sx={{ mr: 1 }} /> Download Excel
                      </MenuItem> */}
                    </Menu>
                  </>
                }
              />
              <Collapse in={overViewExpanded} timeout="auto">
                <CardContent sx={{ height: 430 }}>
                  <PendingTransaction filter={filter} fetchedData={fetchedData} series={series} />
                </CardContent>
              </Collapse>
            </Card>
          </Grid>
          </Grid>

         <Grid container spacing={2} sx={{ marginTop: "5px" }}>

          {/* Card 1 */}

          <Grid item  sx={{ marginTop: "20px" }} xs={12} sm={12} md={12} lg={12} xl={12}>
            <Card
                id="paymentSummaryCard"
              sx={{
                position: "relative",
                overflow: "visible",
                paddingTop: "30px",
                textAlign: "right",
                backGround: "transparent",
                boxShadow: "none",
                minHeight:"inherit"
              }}
            >
              <Box
              className="hide-on-download"
                sx={{
                  background: "linear-gradient(60deg, #66bb6a, #43a047)",
                  boxShadow:
                    "0 4px 20px 0 rgba(0, 0, 0, .14), 0 7px 10px -5px rgba(67, 160, 71, .4)",
                  position: "absolute",
                  top: "-35px", // pushes icon box half above card
                  left: "16px",
                  borderRadius: "10px",
                  padding: "10",
                  width: "80px",
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1,
                }}
                display="flex"
                justifyContent="left"
                mb={1}
              >
                <Summarize sx={{ color: "#fff", fontSize: "60px" }} />
              </Box>
              <CardHeader
                sx={{
                  marginTop: "-30px",
                  paddingLeft: "100px",
                }}
                titleTypographyProps={{ fontWeight: "bold", fontSize: "24px", 
                minHeight: "48px",
                lineHeight: "24px", }}
                title="Payment Summary"
                action={
                  <>
                    {/* Expand/Collapse Button */}
                    <IconButton
                      onClick={() => {
                        setPaymentSummaryExpanded((prev) => !prev);
                      }}
                    >
                      {paymentSummaryExpanded ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>

                    {/* 3-dot Menu */}
                    {paymentSummaryExpanded && (
                      <IconButton
                        onClick={(e) => setPaymentSummaryMenuAnchor(e.currentTarget)}
                        className="hide-on-download"
                      >
                        <MoreVertIcon />
                      </IconButton>
                    )}

                    <Menu
                      anchorEl={paymentSummaryMenuAnchor}
                      open={Boolean(paymentSummaryMenuAnchor)}
                      onClose={() => setPaymentSummaryMenuAnchor(null)}
                    >
                      <MenuItem
                        onClick={() => {
                          handleDownload("paymentSummaryCard", "pdf", "Payment_Summary");
                          setPaymentSummaryMenuAnchor(null);
                        }}
                      >
                        <PictureAsPdfIcon sx={{ mr: 1 }} /> Download PDF
                      </MenuItem>

                      {/* <MenuItem
                        onClick={() => {
                          handleDownload("paymentSummaryCard", "excel", "Payment_Summary");
                          setPaymentSummaryMenuAnchor(null);
                        }}
                      >
                        <InsertDriveFileIcon sx={{ mr: 1 }} /> Download Excel
                      </MenuItem> */}
                    </Menu>
                  </>
                }
              />
              <Collapse in={paymentSummaryExpanded} timeout="auto">
                <CardContent>
                  <PaymentSummary filter={filter} fetchedData={fetchedData} listPayment={listPayment} />
                </CardContent>
              </Collapse>
            </Card>
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ marginTop: "5px" }}>
          {/* Card 1 */}
          <Grid item sx={{ marginTop: "20px" }} xs={12} sm={12} md={12} lg={6} xl={6}>
            <Card
                id="outstandingQueriesCard"
              sx={{
                position: "relative",
                overflow: "visible",
                paddingTop: "30px",
                textAlign: "right",
                backGround: "transparent",
                boxShadow: "none",
                minHeight:"inherit"
              }}
            >
              <Box
              className="hide-on-download"
                sx={{
                  background: "linear-gradient(60deg, #ef5350, #e53935)",
                  boxShadow:
                    "0 4px 20px 0 rgba(0, 0, 0, .14), 0 7px 10px -5px rgba(244, 67, 54, .4)",
                  position: "absolute",
                  top: "-35px",
                  left: "16px",
                  borderRadius: "10px",
                  padding: "10",
                  width: "80px",
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1
                }}
                display="flex"
                justifyContent="left"
                mb={1}
              >
                <QueryStats sx={{ color: "#fff", fontSize: "60px" }} />
              </Box>
              <CardHeader
                sx={{ marginTop: "-30px", paddingLeft: "100px", }}
                titleTypographyProps={{ fontWeight: "bold", fontSize: "24px",
                minHeight: "48px",
                lineHeight: "24px", }}
                title="Outstanding Queries by Days"
                action={
                  <>
                    {/* Expand/Collapse Button */}
                    <IconButton
                      onClick={() => {
                        setOutStandingQueriesExpanded((prev) => !prev);
                      }}
                    >
                      {outStandingQueriesExpanded ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>

                    {/* 3-dot Menu */}
                    {outStandingQueriesExpanded && (
                      <IconButton
                        onClick={(e) => setOutStandingQueriesMenuAnchor(e.currentTarget)}
                        className="hide-on-download"
                      >
                        <MoreVertIcon />
                      </IconButton>
                    )}

                    <Menu
                      anchorEl={outStandingQueriesMenuAnchor}
                      open={Boolean(outStandingQueriesMenuAnchor)}
                      onClose={() => setOutStandingQueriesMenuAnchor(null)}
                    >
                      <MenuItem
                        onClick={() => {
                          handleDownload("outstandingQueriesCard", "pdf", "Outstanding_Queries");
                          setOutStandingQueriesMenuAnchor(null);
                        }}
                      >
                        <PictureAsPdfIcon sx={{ mr: 1 }} /> Download PDF
                      </MenuItem>

                      {/* <MenuItem
                        onClick={() => {
                          handleDownload("outstandingQueriesCard", "excel", "Outstanding_Queries");
                          setOutStandingQueriesMenuAnchor(null);
                        }}
                      >
                        <InsertDriveFileIcon sx={{ mr: 1 }} /> Download Excel
                      </MenuItem> */}
                    </Menu>
                  </>
                }
              />
              <Collapse in={outStandingQueriesExpanded} timeout="auto">
                <CardContent sx={{ height: 430 }}>
                  <OutStandingQueries filter={filter} fetchedData={fetchedData} series={querySeries} categories={categories}/>
                </CardContent>
              </Collapse>
            </Card>
          </Grid>
          {/* Card 2 */}
          <Grid item sx={{ marginTop: "20px" }} xs={12} sm={12} md={12} lg={6} xl={6}>
            <Card
              id="purchaseOrderComplianceCard"
              sx={{
                position: "relative",
                overflow: "visible",
                paddingTop: "30px",
                textAlign: "right",
                backGround: "transparent",
                boxShadow: "none",
                minHeight:"inherit"
              }}
            >
              <Box
              className="hide-on-download"
                sx={{
                  background: "linear-gradient(60deg, #66bb6a, #388e3c)",
                  boxShadow:
                    "0 4px 20px 0 rgba(0, 0, 0, .14), 0 7px 10px -5px rgba(56, 142, 60, .4)",
                  position: "absolute",
                  top: "-35px",
                  left: "16px",
                  borderRadius: "10px",
                  padding: "10",
                  width: "80px",
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1
                }}
                display="flex"
                justifyContent="left"
                mb={1}
              >
                <FactCheck sx={{ color: "#fff", fontSize: "60px" }} />
              </Box>
              <CardHeader
                sx={{ marginTop: "-30px", paddingLeft: "100px", }}
                titleTypographyProps={{ fontWeight: "bold", fontSize: "24px", 
                minHeight: "48px",  
                lineHeight: "24px", }}
                title="Purchase Order Compliance"
                action={
                  <>
                    {/* Expand/Collapse Button */}
                    <IconButton
                      onClick={() => {
                        setPurchaseOrderExpanded((prev) => !prev);
                      }}
                    >
                      {purchaseOrderExpanded ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>

                    {/* 3-dot menu (only visible when expanded) */}
                    {purchaseOrderExpanded && (
                      <IconButton
                        className="hide-on-download"
                        onClick={(e) => setPurchaseOrderMenuAnchor(e.currentTarget)}
                      >
                        <MoreVertIcon />
                      </IconButton>
                    )}

                    <Menu
                      anchorEl={purchaseOrderMenuAnchor}
                      open={Boolean(purchaseOrderMenuAnchor)}
                      onClose={() => setPurchaseOrderMenuAnchor(null)}
                    >
                      <MenuItem
                        onClick={() => {
                          handleDownload("purchaseOrderComplianceCard", "pdf", "Purchase_Order_Compliance");
                          setPurchaseOrderMenuAnchor(null);
                        }}
                      >
                        <PictureAsPdfIcon sx={{ mr: 1 }} /> Download PDF
                      </MenuItem>

                      {/* <MenuItem
                        onClick={() => {
                          handleDownload("purchaseOrderComplianceCard", "excel", "Purchase_Order_Compliance");
                          setPurchaseOrderMenuAnchor(null);
                        }}
                      >
                        <InsertDriveFileIcon sx={{ mr: 1 }} /> Download Excel
                      </MenuItem> */}
                    </Menu>
                  </>
                }
              />
              <Collapse in={purchaseOrderExpanded} timeout="auto" >
                <CardContent sx={{ height: 430 }}>
                  <PurchaseOrderCompilance filter={filter} fetchedData={fetchedData} purchaseOrderCompilance={purchaseOrderCompilance}/>
                </CardContent>
              </Collapse>
            </Card>
          </Grid>
        </Grid>





     <Grid container spacing={2} sx={{marginTop:"5px"}} 
>
          {/* Card 1 */}

          <Grid item  sx={{marginTop:"20px" }}   xs={12} sm={12} md={12} lg={12} xl={12}  >
            <Card
              id="invoiceProcessingCard"
              sx={{
                position: "relative",
                overflow: "visible",
                paddingTop: "30px",
                textAlign: "right",
                backGround: "transparent",
                boxShadow: "none",
                minHeight:"inherit"
              }}
            >
              <Box
              className="hide-on-download"
                sx={{
                       background: "linear-gradient(60deg, #26c6da, #00acc1)",
                  boxShadow:
                    "0 4px 20px 0 rgba(0, 0, 0, .14), 0 7px 10px -5px rgba(0, 172, 193, .4)",
                  position: "absolute",
                  top: "-35px", // pushes icon box half above card
                  left: "16px",
                  borderRadius: "10px",
                  padding: "10",
                  width: "80px",
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1,
                }}
                display="flex"
                justifyContent="left"
                mb={1}
              >
                <Timeline sx={{ color: "#fff", fontSize: "60px" }} />
              </Box>
              <CardHeader
                sx={{
                  marginTop: "-30px",
                  paddingLeft: "100px",
                }}
                titleTypographyProps={{ fontWeight: "bold", fontSize: "24px",
                 minHeight: "48px",  
                 lineHeight: "24px", }}
                title="Overview of Invoice processing days"
                action={
                  <>
                    {/* Expand/Collapse Button */}
                    <IconButton
                      onClick={() => {
                        setInvoiceProcessingExpanded((prev) => !prev);
                      }}
                    >
                      {invoiceProcessingExpanded ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>

                    {/* 3-dot menu (only visible when expanded) */}
                    {invoiceProcessingExpanded && (
                      <IconButton
                        className="hide-on-download"
                        onClick={(e) => setInvoiceMenuAnchor(e.currentTarget)}
                      >
                        <MoreVertIcon />
                      </IconButton>
                    )}

                    {/* ===== Download Menu ===== */}
                    <Menu
                      anchorEl={invoiceMenuAnchor}
                      open={Boolean(invoiceMenuAnchor)}
                      onClose={() => setInvoiceMenuAnchor(null)}
                    >
                      <MenuItem
                        onClick={() => {
                          handleDownload("invoiceProcessingCard", "pdf", "Invoice_Processing_Days");
                          setInvoiceMenuAnchor(null);
                        }}
                      >
                        <PictureAsPdfIcon sx={{ mr: 1 }} /> Download PDF
                      </MenuItem>
                      {/* <MenuItem
                        onClick={() => {
                          handleDownload("invoiceProcessingCard", "excel", "Invoice_Processing_Days");
                          setInvoiceMenuAnchor(null);
                        }}
                      >
                        <InsertDriveFileIcon sx={{ mr: 1 }} /> Download Excel
                      </MenuItem> */}
                    </Menu>
                  </>
                }
              />
              <Collapse in={invoiceProcessingExpanded} timeout="auto" >
                <CardContent>
              <InvoiceProcessingdays filter={filter} fetchedData={fetchedData} data={invoiceProcessingData} setLoading={setLoading} />
                </CardContent>
              </Collapse>
            </Card>
          </Grid>
          {successMessage && (
            <CustomSnackbar
              open={successMessage !== ""}
              message={successMessage}
              handleClose={() => setSuccessMessage("")}
              variant="success"
            />
          )}    
                    {apiErrorMessage && (
            <CustomSnackbar
              open={apiErrorMessage !== ""}
              message={apiErrorMessage}
              handleClose={() => setApiErrorMessage("")}
              variant="error"
            />
          )}
     


        </Grid>



      </div>
    </>

    // <div style={{ backgroundColor: "white", height: "auto", padding: "10px" }}>
    //   <div class="scrollbar" id="style-2">
    //     <div class="force-overflow"></div>
    //   </div>
    //   <Paper
    //     style={{
    //       padding: 20,
    //       textAlign: "center",
    //       marginTop: "2%",
    //       marginBottom: "3%",
    //       backgroundColor: "#031C30",
    //       fontFamily: "DM Sans,sans-serif",
    //       color: "white",
    //       fontWeight: 500,
    //       fontSize: 18,
    //     }}
    //   >
    //     ACCOUNT PAYABLE DASHBOARD
    //   </Paper>
    //   <Grid container>
    //     <Grid item xs={3} md={3} mb={2} mr={2}>
    //       <Typography>Year</Typography>

    //       <Autocomplete
    //         sx={{
    //           "& .MuiInputBase-root": {
    //             height: "30px",
    //             textAlign: "center",
    //             display: "flex",
    //             alignItems: "center",
    //           },
    //           "& .MuiInputBase-input": {
    //             marginTop: "-4px", // Adjust this value to move the text up
    //             fontSize: 15,
    //           },
    //         }}
    //         id="month"
    //         options={Validyears}
    //         // classes={{ option: classes.option }}
    //         size="small"
    //         name="year"
    //         // value={formState?.maturityPeriod || ""}
    //         getOptionLabel={(option) => option.toString()}
    //         // loading={vendorLoading}
    //         onChange={(event, newValue) => {
    //           changeHandler("year", newValue);
    //         }}
    //         renderInput={(params) => (
    //           <TextField
    //             // sx={{ input: { color: "#888888" } }}
    //             {...params}
    //             name=""
    //             required
    //             value={""}
    //             // onChange={changeHandler}
    //             InputProps={{
    //               ...params.InputProps,
    //               endAdornment: (
    //                 <React.Fragment>
    //                   {params.InputProps.endAdornment}
    //                 </React.Fragment>
    //               ),
    //             }}
    //           />
    //         )}
    //       />
    //       {errorMessage?.yearError && (
    //         <>
    //           {" "}
    //           <Grid container spacing={0}>
    //             <Grid item>
    //               <Error
    //                 titleAccess="Error"
    //                 className={classes.asterisk}
    //                 fontSize="small"
    //               />{" "}
    //             </Grid>
    //             <Grid item>
    //               <Typography className={classes.asterisk} ml={1}>
    //                 {" "}
    //                 {errorMessage?.yearError}
    //               </Typography>
    //             </Grid>
    //           </Grid>
    //         </>
    //       )}
    //     </Grid>
    //     <Grid item xs={3} md={3} mb={2} mr={2}>
    //       <Typography>Month</Typography>

    //       <Autocomplete
    //         sx={{
    //           "& .MuiInputBase-root": {
    //             height: "30px",
    //             textAlign: "center",
    //             display: "flex",
    //             alignItems: "center",
    //           },
    //           "& .MuiInputBase-input": {
    //             marginTop: "-4px", // Adjust this value to move the text up
    //             fontSize: 15,
    //           },
    //         }}
    //         options={monthOptions}
    //         disabled={!filter?.year}
    //         size="small"
    //         name="month"
    //         value={
    //           monthOptions.find((option) => option.value === filter?.month) ||
    //           null
    //         }
    //         getOptionLabel={(option) => option?.label || ""}
    //         isOptionEqualToValue={(option, value) => option?.value === value}
    //         onChange={(event, newValue) => {
    //           changeHandler("month", newValue?.value || "");
    //         }}
    //         renderInput={(params) => (
    //           <TextField
    //             {...params}
    //             required
    //             InputProps={{
    //               ...params.InputProps,
    //               endAdornment: (
    //                 <React.Fragment>
    //                   {params.InputProps.endAdornment}
    //                 </React.Fragment>
    //               ),
    //             }}
    //           />
    //         )}
    //       />

    //       {errorMessage?.monthError && (
    //         <>
    //           {" "}
    //           <Grid container spacing={0}>
    //             <Grid item>
    //               <Error
    //                 titleAccess="Error"
    //                 className={classes.asterisk}
    //                 fontSize="small"
    //               />{" "}
    //             </Grid>
    //             <Grid item>
    //               <Typography className={classes.asterisk} ml={1}>
    //                 {" "}
    //                 {errorMessage?.monthError}
    //               </Typography>
    //             </Grid>
    //           </Grid>
    //         </>
    //       )}
    //     </Grid>
    //     <Grid item xs={3} md={3} mb={2}>
    //       <Button
    //         style={{
    //           height: "40px", // Match Autocomplete with padding
    //           color: "white",
    //           backgroundColor: "#808080",
    //           marginTop: "16px", // Optional: to align perfectly with Autocomplete
    //         }}
    //         variant="contained"
    //         color="secondary"
    //         type="submit"
    //         id="proceed"
    //         // disabled={
    //         //   !formState?.isLogistics
    //         //     ? selectedRole?.roleName === "IR" &&
    //         //       poBasedState === "PO" &&
    //         //       formState?.invoice_Amount != selectedTotal
    //         //     : false
    //         // }
    //         onClick={filterHandler}
    //       >
    //         Filter
    //       </Button>
    //     </Grid>
    //   </Grid>
    //   <Grid container spacing={1}>
    //     <Grid item xs={12} md={12}>
    //       <div>
    //         <AccountPayableCountTable
    //           filter={filter}
    //           fetchedData={fetchedData}
    //         />
    //       </div>
    //     </Grid>
    //   </Grid>
    //   <Grid container spacing={1} style={{ marginTop: "1%" }}>
    //     <Grid item xs={12} md={6}>
    //       <VendorFinancingTable PayableCountsList={PayableCountsList} />
    //     </Grid>
    //     <Grid item xs={12} md={6}>
    //       <ShippingPayment PayableCountsList={PayableCountsList} />
    //     </Grid>
    //   </Grid>
    //   <Grid container spacing={1} style={{ marginTop: "1%" }}>
    //     <Grid item xs={12} md={6}>
    //       <div>
    //         <EmpolyeeMade
    //           PayableCountsList={PayableCountsList}
    //           filter={filter}
    //           fetchedData={fetchedData}
    //         />
    //       </div>
    //     </Grid>
    //     <Grid item xs={12} md={6}>
    //       <div>
    //         <ChequeMade PayableCountsList={PayableCountsList} />
    //       </div>
    //     </Grid>
    //   </Grid>
    //   <Grid container>
    //     <Grid item xs={12} md={6}>
    //       <div
    //         style={{
    //           padding: 20,
    //           textAlign: "center",
    //           marginTop: "2%",
    //           marginBottom: "4%",
    //           backgroundColor: "#031C30",
    //           fontFamily: "DM Sans,sans-serif",
    //           color: "white",
    //           fontWeight: 500,
    //           fontSize: 18,
    //         }}
    //       >
    //         Accounts Payable Overview
    //       </div>
    //       <div
    //         style={{
    //           marginInline: "5%",
    //           maxHeight: "515px",
    //           overflow: "auto",
    //           scrollbarWidth: "thin",
    //         }}
    //       >
    //         {" "}
    //         <AccountPayableOverView filter={filter} fetchedData={fetchedData} />
    //       </div>
    //     </Grid>
    //     <Grid item xs={12} md={6}>
    //       <div
    //         style={{
    //           padding: 20,
    //           textAlign: "center",
    //           marginTop: "2%",
    //           marginBottom: "4%",
    //           backgroundColor: "#031C30",
    //           fontFamily: "DM Sans,sans-serif",
    //           color: "white",
    //           fontWeight: 500,
    //           fontSize: 18,
    //         }}
    //       >
    //         Credit Term Compilance Overview
    //       </div>
    //       <div style={{ marginInline: "2%" }}>
    //         {" "}
    //         <ComplianceOver filter={filter} fetchedData={fetchedData} />{" "}
    //       </div>
    //     </Grid>
    //   </Grid>
    //   <Grid container>
    //     <Grid item xs={12} md={6}>
    //       <div
    //         style={{
    //           padding: 20,
    //           textAlign: "center",
    //           marginTop: "2%",
    //           marginBottom: "4%",
    //           backgroundColor: "#031C30",
    //           fontFamily: "DM Sans,sans-serif",
    //           color: "white",
    //           fontWeight: 500,
    //           fontSize: 18,
    //         }}
    //       >
    //         Overview of Pending Transactions
    //       </div>
    //       <div style={{ marginInline: "2%" }}>
    //         {" "}
    //         <PendingTransaction filter={filter} fetchedData={fetchedData} />
    //       </div>
    //     </Grid>
    //     <Grid item xs={12} md={6}>
    //       <div
    //         style={{
    //           padding: 20,
    //           textAlign: "center",
    //           marginTop: "2%",
    //           marginBottom: "4%",
    //           backgroundColor: "#031C30",
    //           fontFamily: "DM Sans,sans-serif",
    //           color: "white",
    //           fontWeight: 500,
    //           fontSize: 18,
    //         }}
    //       >
    //         Payment Summary
    //       </div>
    //       <div style={{ marginInline: "2%" }}>
    //         {" "}
    //         <PaymentSummary filter={filter} fetchedData={fetchedData} />
    //       </div>
    //     </Grid>
    //   </Grid>
    //   <Grid container>
    //     <Grid item xs={12} md={6}>
    //       <div
    //         style={{
    //           padding: 20,
    //           textAlign: "center",
    //           marginTop: "2%",
    //           marginBottom: "4%",
    //           backgroundColor: "#031C30",
    //           fontFamily: "DM Sans,sans-serif",
    //           color: "white",
    //           fontWeight: 500,
    //           fontSize: 18,
    //         }}
    //       >
    //         Outstanding Quries by Days{" "}
    //       </div>
    //       <div style={{ marginInline: "2%", paddingBottom: "5%" }}>
    //         {" "}
    //         <OutStandingQueries filter={filter} fetchedData={fetchedData} />
    //       </div>
    //     </Grid>
    //     <Grid item xs={12} md={6}>
    //       <div
    //         style={{
    //           padding: 20,
    //           textAlign: "center",
    //           marginTop: "2%",
    //           marginBottom: "4%",
    //           backgroundColor: "#031C30",
    //           fontFamily: "DM Sans,sans-serif",
    //           color: "white",
    //           fontWeight: 500,
    //           fontSize: 18,
    //         }}
    //       >
    //         Purchase Order Compliance
    //       </div>
    //       <div style={{ marginInline: "2%", paddingBottom: "5%" }}>
    //         {" "}
    //         <PurchaseOrderCompilance
    //           filter={filter}
    //           fetchedData={fetchedData}
    //         />
    //       </div>
    //     </Grid>
    //   </Grid>
    //   <Grid container>
    //     <Grid item xs={12} md={12}>
    //       <div
    //         style={{
    //           padding: 20,
    //           textAlign: "center",
    //           marginTop: "2%",
    //           marginBottom: "3%",
    //           backgroundColor: "#031C30",
    //           fontFamily: "DM Sans,sans-serif",
    //           color: "white",
    //           fontWeight: 500,
    //           fontSize: 18,
    //         }}
    //       >
    //         Overview of Invoice processing days:
    //       </div>
    //       <div style={{ marginInline: "2%", paddingBottom: "5%" }}>
    //         {" "}
    //         <InvoiceProcessingdays filter={filter} fetchedData={fetchedData} />
    //       </div>
    //     </Grid>
    //   </Grid>
    // </div>
  );
}
